/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const environmentOutlinerTokens = {
  CoreBorderStyle: 'solid',
  CoreBorderWidth: '5px',
  ProductionColor: '#ddb31f',
  ProductionButtonTextColor: '#000000',
  ImpersonateColor: '#da1c3c',
  ImpersonateButtonTextColor: '#ffffff',
  InkDyeColor: '#285da3',
  InkDyeButtonTextColor: '#ffffff',
} as const;
